/**
 * Get the basename for React Router
 * This ensures all redirects work correctly with the PUBLIC_URL
 */
export const getBasename = (): string => {
  // Get from environment variable first
  const publicUrl = process.env.PUBLIC_URL || '';
  
  // Normalize: ensure it starts with / and doesn't end with /
  if (publicUrl) {
    return publicUrl.startsWith('/') 
      ? publicUrl.endsWith('/') 
        ? publicUrl.slice(0, -1) 
        : publicUrl
      : `/${publicUrl}`;
  }
  
  // Fallback: try to get from window location if PUBLIC_URL is not set
  // This is useful for development
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    // If pathname starts with /xbox, use it as basename
    if (pathname.startsWith('/xbox')) {
      return '/xbox';
    }
  }
  
  return '';
};

/**
 * Get full path with basename
 * Use this for window.location.href redirects
 */
export const getPathWithBasename = (path: string): string => {
  const basename = getBasename();
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Combine basename and path, avoiding double slashes
  return basename ? `${basename}${normalizedPath}` : normalizedPath;
};




